class TaskMessageTemplatePermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'task_message_template.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'task_message_template._m';

    // Can access archived templates
    static ACCESS_ARCHIVE = 'task_message_template.access.archive';

    // Can create template
    static CREATE = 'task_message_template.create';

    // Can update template
    static UPDATE = 'task_message_template.update';

    // Can archive template
    static ARCHIVE = 'task_message_template.archive';

    // Can restore archived template
    static RESTORE = 'task_message_template.restore';
}

export default TaskMessageTemplatePermission;
